export default __webpack_public_path__ + "static/media/reason.271e0821.svg";